import { render, staticRenderFns } from "./preRegistProductTab.vue?vue&type=template&id=4d3cc0cd&"
import script from "./preRegistProductTab.vue?vue&type=script&lang=js&"
export * from "./preRegistProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports